import React, { useRef } from 'react';
import { Tile } from './Tile';

interface RowProps {
  letters: string[];
  states: ('empty' | 'G' | 'R')[];
  editable?: boolean;
  flippingTiles: {row: number, tile: number}[]; // Add this
  rowIndex: number; // Add this
  onTileChange?: (col: number, value: string) => void;
}

export const Row: React.FC<RowProps> = ({ 
  letters, 
  states, 
  editable = false, 
  flippingTiles, 
  rowIndex, 
  onTileChange 
}) => {
  // DEBUG: Log every row render
  // console.log(`🚀 Row ${rowIndex} rendered - editable: ${editable}, states: [${states}], flippingTiles count: ${flippingTiles.length}`);
  // console.log(`   Row ${rowIndex} flippingTiles:`, flippingTiles.filter(tile => tile.row === rowIndex));
  
  const inputsRef = useRef<Array<HTMLInputElement | null>>(new Array(letters.length).fill(null));

  const handleChange = (idx: number, value: string) => {
    if (!editable) return;
    onTileChange?.(idx, value);
    if (value && inputsRef.current[idx + 1]) {
      inputsRef.current[idx + 1]?.focus();
    }
  };

  const handleBackspace = (idx: number) => {
    if (idx > 0 && inputsRef.current[idx - 1]) {
      const prevInput = inputsRef.current[idx - 1];
      prevInput!.focus();
      prevInput!.value = '';
      onTileChange?.(idx - 1, '');
    }
  };

  return (
    <div className="flex justify-center gap-1">
      {letters.map((letter, idx) => {
        // Only flip if it's the correct row AND correct tile
        const shouldFlip = flippingTiles.some(
          tile => tile.row === rowIndex && tile.tile === idx
        );
        
        // console.log(`   Row ${rowIndex} Tile ${idx} - letter: "${letter}", state: "${states[idx]}", shouldFlip: ${shouldFlip}`);
        
        return (
          <Tile
            key={idx}
            letter={letter}
            state={states[idx]}
            editable={editable}
            flip={shouldFlip}
            ref={(el): void => { inputsRef.current[idx] = el; }}
            onChange={value => handleChange(idx, value.toUpperCase().slice(0, 1))}
            onBackspace={() => handleBackspace(idx)}
          />
        );
      })}
    </div>
  );
};